import { useQuery } from '@tanstack/react-query';
import { KmsDocumentService } from '~/app/services/kms/kms-document.service';
import { isTerminalKmsStatus } from '~/app/services/kms/kms-document.utils';

export function useKmsDocumentStatus(
  documentId: string | null,
  organizationId?: string | null,
  isSuperAdmin = false,
) {
  return useQuery({
    queryKey: [
      'kms',
      'document-status',
      documentId,
      organizationId,
      isSuperAdmin,
    ],
    queryFn: () =>
      KmsDocumentService.getStatus(documentId!, organizationId, isSuperAdmin),
    enabled: Boolean(documentId),
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (!status || isTerminalKmsStatus(status)) {
        return false;
      }
      return 5_000;
    },
  });
}
